<template>
   <div class="tab" data-name="jobInfo" data-type="form">
      <div class="row mb-3">
         <div class="col-12">
             <h3>فرم سوابق شغلی</h3>
      <p>[این فرم مربوط به سابقه کاری و علاقه مندی شما می باشد]</p>
         </div>
      </div>
     
      <div class="row mb-3">
         <div class="col-4">
            <label for="currentJob">وضعیت فعلی اشتغال</label>
         </div>
         <div class="col-8">
            <input
               type="text"
               class="form-control"
               name="currentJob"
               id="currentJob"
               placeholder
               data-pattern="checkEmpty"
            />
            <label id="currentJob" class="error"></label>
         </div>
      </div>
      <div class="row mb-3">
         <div class="col-4">
            <label
               for="last"
            >ایا قبلا برای استخدام به این شرکت مراجعه کرده اید؟</label>
         </div>
         <div class="col-8">
            <input type="text" class="form-control" name="recruitment" id="recruitment" />
         </div>
      </div>
      <div class="row mb-3">
         <div class="col-4">
            <label for="introduce">از چه طریقی به شرکت معرفی شده اید؟</label>
         </div>
         <div class="col-8">
            <input
               type="text"
               class="form-control"
               name="introduce"
               id="introduce"
               data-pattern="checkEmpty"
            />
            <label id="introduce" class="error"></label>
         </div>
      </div>
      <div class="row mb-3">
         <div class="col-4">
            <label for="favorite">به چه کاری علاقه دارید؟</label>
         </div>
         <div class="col-8">
            <input type="text" class="form-control" name="favorite" id="favorite" />
         </div>
      </div>
      <div class="row mb-3">
         <div class="col-4">
            <label for="hours">روزانه چند ساعت میتوانید اضافه کاری نمایید؟</label>
         </div>
         <div class="col-8">
            <input
               type="text"
               class="form-control"
               name="hours"
               id="hours"
               data-pattern="checkEmpty"
            />
            <label id="hours" class="error"></label>
         </div>
      </div>
      <div class="row mb-3">
         <div class="col-4">
            <label for="salary">حقوق درخواستی شما چقدر است؟</label>
         </div>
         <div class="col-8">
            <input type="text" class="form-control" name="salary" id="salary" />
         </div>
      </div>
      <div class="row mb-3">
         <div class="col-4">
            <label for="start">تاریخ شروع همکاری</label>
         </div>
         <div class="col-8">
            <input
               type="text"
               class="form-control"
               name="start"
               id="start"
               data-pattern="checkEmpty"
            />
            <label id="start" class="error"></label>
         </div>
      </div>
      <div class="row mb-3">
         <div class="col-4">
            <label for="criminal">ایا سابقه محکومیت کیفری دارید؟</label>
         </div>
         <div class="col-8">
            <input type="text" class="form-control" name="criminal" id="criminal" />
         </div>
      </div>
      <div class="row mb-3">
         <div class="col-4">
            <label for="addictive">ایا تاکنون به مواد مخدر اعتیاد داشته اید؟</label>
         </div>
         <div class="col-8">
            <input
               type="text"
               class="form-control"
               name="addictive"
               id="addictive"
               placeholder="در صورت اثبات اعتیاد شرکت مختار است نسبت به قطع همکاری و اخراج اقدام نماید. "
            />
         </div>
      </div>
   </div>
</template>
<style scoped>

</style>
<script>
export default {
   emits: ["change"],
   props: {
      init: {
         type: Function,
      },
   },

   change(e) {
      this.$emit("change", e.target);
   },

   mounted() {
      this.init();
   },
};
</script>